import classNames from "classnames";

interface TextProps {
  className?: string;
  variant?: "body" | "small" | "detail";
  color?: string;
  children?: React.ReactNode;
}

export default function Text({ 
  className = "",
  variant = "body",
  color = "",
  children,
}: TextProps) {

  return (
    <p className={classNames({
        "text-[18px] md:text-[20px] xl:text-[24px]": variant == "body",
        "text-[16px] md:text-[18px]": variant == "small",
        "text-black dark:text-beige": !color,
      }, className, color)}
    >
      {children}
    </p>
  );
};